import type { SideKey } from '~/utils/scanSource/deviceBridge'

/**
 * The tablet's side buttons (owner, 2026-10-14): P1, P2 and P3 open the three
 * jobs, and the home screen's tiles are labelled with the same names, so the
 * button and the tile say the same thing.
 *
 * `to` is where the button goes: the tile's own address (Load Truck and Unload
 * Truck start at their list of trucks). `at` is every screen of that job; a
 * press while already on one of them does nothing, so a driver on Load Truck
 * who presses P2 does not lose the truck he is loading.
 */
export const SIDE_KEY_JOBS: Record<SideKey, { to: string, at: readonly string[] }> = {
  P1: { to: '/move-pallets', at: ['/move-pallets'] },
  P2: { to: '/orders', at: ['/orders', '/load-truck'] },
  P3: { to: '/unload-orders', at: ['/unload-orders', '/unload-truck'] },
}

/** Where a press of `button` should go from `path`, or null to stay. */
export function sideKeyTarget(button: SideKey, path: string): string | null {
  const job = SIDE_KEY_JOBS[button]
  const here = path.replace(/\/+$/, '') || '/'
  return job.at.includes(here) ? null : job.to
}
